<h1 class="kh-heading-md kh-text-primary" data-testid="heading-insights-summary">
  {{ 'REPORTS_TOP_GAP_COMPONENT.INSIGHTS_SUMMARY' | translate }}
</h1>
<div class="focus-area kh-rounded-xl kh-bg-light mt-kh-2">

  <!-- Section Title with Conditional Pluralization and Count -->
  <h2 class="focus-title kh-title-lg kh-text-primary" #focusAreaAnchor data-testid="focus-area-identified">
    {{ 'REPORTS_TOP_GAP_COMPONENT.FOCUS_AREAS_TITLE' | translate:{ count: studentGaps.length } }}
  </h2>

  <div>
    <p class="focus-subtext kh-body-md kh-text-secondary">
      {{ 'REPORTS_TOP_GAP_COMPONENT.YOUR_CLASS_HAS_FACED_CHALLENGES' | translate:{ count: studentGaps.length } }}
    </p>
  </div>

  <div *ngIf="studentGaps.length > 0" class="gap-list">

    <!-- Loop through gaps; show one or all based on toggle state -->
    <div *ngFor="let gap of showAllGaps ? studentGaps : [studentGaps[0]]" class="gap-item">

      <div class="gap-header">

        <!-- Gap Title and Percentage Container -->
        <div class="gap-title-container">
          <h3 class="gap-title kh-title-lg kh-text-primary" data-testid="gap-title">
            {{ gap.SubjectName }}
          </h3>

          <div class="gap-percentage-container">
            <div class="icon-container">
              <fa-icon class="arrow-icon" [icon]="['fas', 'arrow-down']"></fa-icon>
              <fa-icon class="user-icon" [icon]="['fas', 'user']"></fa-icon>
            </div>

            <div>
              <span class="gap-percentage" data-testid="gap-percentage">
                {{ gap.PercentageStruggling }}%
              </span>

              <p class="struggling-text">
                {{ 'REPORTS_TOP_GAP_COMPONENT.STUDENTS_STRUGGLING' | translate }}
              </p>
            </div>
          </div>
        </div>

        <!-- View Supports Button -->
        <button
          class="view-supports-button"
          (click)="onViewTeacherSupportClick(gap.LogicalErrorId)"
          data-testid="view-supports-button">
          {{ 'REPORTS_TOP_GAP_COMPONENT.VIEW_TEACHER_SUPPORTS' | translate }}
        </button>

      </div>

      <!-- Gap Reason -->
      <p class="gap-reason kh-body-md">
        {{ 'REPORTS_TOP_GAP_COMPONENT.WHY_ARE_GAP_PERCENTAGE_STRUGGLING' | translate:{ gapPercentageStruggling: gap.PercentageStruggling } }}
      </p>

      <!-- Misconceptions Section -->
      <div class="misconceptions-container">
        <kh-img class="light-bulb-img" path="/remediation-icon-md.png"></kh-img>

        <div class="misconceptions">
          <h4 class="kh-title-md kh-text-primary">
            {{ 'REPORTS_TOP_GAP_COMPONENT.COMMON_MISCONCEPTIONS' | translate }}
          </h4>

          <ol class="kh-body-md kh-text-secondary">
            <li *ngFor="let misconception of gap.StruggleReasons">
              {{ misconception }}
            </li>
          </ol>
        </div>
      </div>

    </div>

    <!-- Buttons for Viewing All Gaps and Measuring Growth -->
    <div class="button-container">

      <!-- Toggle Button to View All or Hide -->
      <div *ngIf="studentGaps.length > 1">
        <button (click)="toggleGaps()" class="kh-title-md text-link-primary view-all-button">

          <div *ngIf="showAllGaps">
            {{ 'REPORTS_TOP_GAP_COMPONENT.HIDE' | translate }}
          </div>

          <div *ngIf="!showAllGaps">
            {{ 'REPORTS_TOP_GAP_COMPONENT.VIEW_ALL_STUDENT_GAPS' | translate:{ studentGapsLength: studentGaps.length } }}
          </div>

        </button>
      </div>

      <!-- Measure Growth Button -->
      <button
        (click)="measureGrowthClicked.emit()"
        class="measure-growth-button"
        data-testid="measure-growth-button">

        {{ 'REPORTS_TOP_GAP_COMPONENT.MEASURE_GROWTH' | translate }}

      </button>

    </div>
  </div>
</div>